import React, { Component } from "react";
import Modal from 'react-modal';
import Call from '../Videocall/Call.js';

const styleMdl =
{
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        height: '100%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '1990px',
        zIndex: '9999999999999999 !important',
        background: "transparent"
    },
    overlay: { zIndex: 999999, }
}

export default class VideoCallComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            channel: '',
            uid: '',
            recebendoLigacao: false,
            recebendoLigacaoObj: null,
            recebendoLigacaoObjID: null,
            ligacaoObj: null,
            ligacaoObjID: null,
            emLigacao: false,
            usuarioLigando: {}
        };
    }

    render() {
        return (
            <Modal
                isOpen={this.props.startCall}
                style={styleMdl}
            >
                <div style={{
                    background: "rgba(0,0,0,0.8)",
                    position: "absolute",
                    top: "0px",
                    left: "0px",
                    right: "0px",
                    bottom: "0px",
                    zIndex: '9999999999999999 !important',
                }}>

                    {(this.props.usuarioLigando ?
                        (
                            <center style={{ marginTop: "5%" }}>
                                <h4 style={{ color: "#fff" }}>Chamando...</h4>
                                <h2 style={{ color: "#fff" }}>
                                    <br />
                                    <img style={{ width: '95px' }}
                                        src={this.props.usuarioLigando.avatarURL ?
                                            this.props.usuarioLigando.avatarURL :
                                            'https://firebasestorage.googleapis.com/v0/b/globalbrain-ba498.appspot.com/o/images%2Fno-user.jpg?alt=media&token=44616cc9-46e2-40ea-906f-28e46f58fb68'} className="rounded-circle" alt="user" />
                                    <br />
                                    <span className="userName">
                                        {this.props.usuarioLigando ?
                                            this.props.usuarioLigando.nome ?
                                                this.props.usuarioLigando.nome :
                                                this.props.usuarioLigando.firstname : null}
                                    </span>
                                    <br />
                                </h2>
                            </center>
                        ) : null)}
                    <div style={{ width: '100%', height: '100%' }}>
                        <Call
                            local={this.props.startCall}
                            channel={this.props.channel}
                            // anotherUser={ }
                            endCall={() => this.props.finishCall()}
                            changeOnCall={() => this.changeOnCall()}
                            style={{ width: '100%', height: '100%', position: "absolute", right: "0px", bottom: "0px", top: '0px', left: '0px' }} />

                        {this.props.emLigacao ? (
                            <div>
                                <button className="btn btn-rounded btn-danger btn-lg" style={{
                                    width: "70px",
                                    height: "70px",
                                    fontSize: "30px",
                                    marginRight: "60px",
                                    position: 'absolute',
                                    bottom: '8px',
                                    marginLeft: '-35px',
                                    left: '50%'
                                }} onClick={() => {
                                    this.props.finishCall();
                                }}><i className="fa fa-times"></i
                                ></button>
                            </div>
                        ) : null}
                    </div>
                    <video
                        id="agora_local"
                        style={{ width: "30%", height: "40%", position: "absolute", right: "0px", bottom: "0px", objectFit: 'scale-down !important' }} />
                </div>
            </Modal>
        )
    }
}